async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}

$(function(){
      function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);     
        $('.cart-count-bubble span').text(result);
      });
    }
        $(document).ready(function(){
      getCartCount();
    });    
          $(document).on('click','.u_uppsell_pro_btn',function(){
     let variant_id = $(this).attr('var-id').trim()
     let ths = $(this);
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data : {
        "id": variant_id,
        "quantity": 1,        
      },
 dataType: 'json',
    beforeSend: function () {
        // setting a timeout
        console.log("before enter");
     ths.addClass("custom----disabled");
        ths.closest(".u_uppsel_pro_row").attr("style", "opacity:.3");
        ths.closest(".u_uppsel_pro_row").find(".u_cart_spinner").show();
      },
        success: function(result){
        console.log('add to cart');
        updateCartDrawer();
         setTimeout(function(){
        getCartCount();                   
      }, 1000);
      },
             error: function(err) {
               console.log('error',err)
      },
         complete: function () {
              setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_uppsel_pro_row").attr("style", "opacity:1");
          ths.closest(".u_uppsel_pro_row").find(".u_cart_spinner").hide();
        }, 1000);
      }
    })
    })
    
         $(document).on('click','.header__icon--cart',function(){
        $('html').addClass("u_overflow");
     })
        $(document).on('click','.drawer__close',function(){
        $('html').removeClass("u_overflow");
     })
     $(document).on('click','.cart-drawer__overlay',function(){
        $('.drawer__close').trigger('click')
     })
  $(document).on('click','.product-form__submit,.vr-buy-now-btn',function(){
    console.log('clicked')
      $('html').addClass("u_overflow");
      setTimeout(function(){
        console.log('TREKRFKEW')
          if(!$('.u_ship_inp').is(':checked')){
        $('.u_ship_inp').trigger('click')
          }
  },1500);
})
      $(document).on('change','.u_ship_inp',function(){
    console.log('changed')
     if($(this).is(':checked')){
        console.log('checked')
       var vid = $(this).attr('var-id');
       let qty = $(this).attr('var-qty')
  let ths = $(this)
   $.ajax({
url:'/cart/add.js',
type:'post',
dataType:'json',
data:{
        quantity: qty, 
        id: vid
},
    success:function(){
      console.log('addon product addedd successfully');  
updateCartDrawer();
         setTimeout(function(){
        getCartCount();                   
      }, 1000);
    },
       error:function(err){
          console.log("Error",err);
        }
})        
     }
     else{
        console.log('unchecked')
       var vid = $(this).attr('var-id');
  let ths = $(this)
   $.ajax({
url:'/cart/change.js',
type:'post',
dataType:'json',
data:{
        quantity: 0, 
        id: vid
},
    success:function(){
      console.log('addon product removed successfully');  
updateCartDrawer();
         setTimeout(function(){
        getCartCount();                   
      }, 1000);
    },
       error:function(err){
          console.log("Error",err);
        }
})        
     }
  })

   $(document).on('click','.u_cart_remove_button',function(){
      let gift_id = $('.u_ship_inp').attr('var-id').trim();
       setTimeout(function(){
               $.getJSON('/cart.js', function(cart){ 
      console.log(cart);
      var result = cart.item_count;
      console.log(result);
      if(result == '1' ){
         $.ajax({
        type:'POST',
        url:'/cart/change.js',
        data : {
        "id": gift_id  ,
        "quantity": 0,        
      },
 dataType: 'json',
        success: function(result){
        console.log('success');   
          setTimeout(function(){
          updateCartDrawer()
          getCartCount()
          },1000)
      },
             error: function(err) {
        console.log('error',err); 
      },
         complete: function() {
                      console.log('complete');           
      }
    })
  }
               })
       },1000)   
                  })
    //                $(document).on('click','.u_header_dicon svg',function(){
    //                 console.log('dwqdew')
    //     $('html').toggleClass("u_overflow");
    //  })
    //                 $(document).on('click','.drawer__close',function(){
    //     $('html').removeClass("u_overflow");
    //  })
})